import React, { useEffect } from "react";
import { gsap } from "gsap";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
gsap.registerPlugin(MorphSVGPlugin);

const Three = () => {
  useEffect(() => {
    gsap.set("#ring-three-path", { autoAlpha: 0 });
    gsap.set("#ring-three-text", {
      autoAlpha: 0,
      scale: 0,
      transformOrigin: "center center",
    });
    gsap.set("#ring3-circ-before", {
      scale: 0,
      transformOrigin: "center center",
    });
    gsap.to("#int3", { y: 10, yoyo: true, repeat: -1, delay: 0.6 });
  }, []);

  const drawRing = () => {
    gsap.to(".ring3-before", { duration: 1, morphSVG: ".ring3-after" });
    gsap.to("#ring-three-text", {
      autoAlpha: 1,
      duration: 1,
      scale: 0.8,
      transformOrigin: "center center",
      delay: 0.3,
    });
  };

  const hoverRing = () => {
    // gsap.to('#ring3-circ-before',{fill: '#fff',scale: 1,transformOrigin: 'center center'})
    gsap.to(".ring3-before", { duration: 1, morphSVG: ".ring3-after" });
    gsap.to("#ring-three-text", {
      autoAlpha: 1,
      duration: 1,
      scale: 0.8,
      transformOrigin: "center center",
      delay: 0.3,
    });
  };

  const leaveRing = () => {
    gsap.to("#ring3-circ-before", {
      fill: "#000",
      scale: 0,
      transformOrigin: "center center",
    });
  };

  return (
    <svg
      id="int3"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 256 255.7"
      style={{ enableBackground: "new 0 0 256 255.7" }}
      onMouseEnter={hoverRing}
      onMouseLeave={leaveRing}
    >
      <g id="Layer_1">
        <g>
          <g>
            <path
              className="ring3-before"
              id="ring3-circ-before"
              style={{ fill: "#000000" }}
              d="M128.3,10.3c31.4,0,61,12.2,83.2,34.5C233.8,67,246,96.5,246,128s-12.2,61-34.5,83.2
				c-22.2,22.2-51.8,34.5-83.2,34.5s-61-12.2-83.2-34.5C22.9,189,10.6,159.4,10.6,128s12.2-61,34.5-83.2
				C67.3,22.5,96.9,10.3,128.3,10.3 M128.3,0.3C57.8,0.3,0.6,57.4,0.6,128s57.2,127.7,127.7,127.7S256,198.5,256,128
				S198.9,0.3,128.3,0.3L128.3,0.3z"
            />
          </g>
        </g>
        <g>
          <path
            className="ring3-before"
            style={{ fill: "#F6B74B" }}
            d="M158.5,100.5c0,10.7-5.7,18.6-15.2,23.1c10.7,4.2,17.4,12.3,17.4,23.3c0,20-18.2,29.7-37.4,29.7
			c-15.2,0-27.8-5.4-35.5-14.7L99.6,149c5.9,6.2,14.4,9.7,23.1,9.7c9.9,0,17.8-4.3,17.8-13.2c0-8.7-8.9-13.3-19.9-13.3h-11.8v-17.4
			h11.9c9.9,0,17.8-4.3,17.8-12.9c0-8.2-7.4-12.7-16.8-12.7c-9.4,0-16.4,4.9-20.5,10.3L88.7,87.1c6.7-9,17.7-15.7,33.9-15.7
			C143.9,71.4,158.5,83,158.5,100.5z"
          />
        </g>
      </g>
      <g id="Layer_2">
        <g>
          <g>
            <path
              className="ring3-after"
              style={{ fill: "#F6B74B" }}
              id="ring-three-path"
              d="M128.3,10.3c31.4,0,61,12.2,83.2,34.5C233.8,67,246,96.5,246,128s-12.2,61-34.5,83.2
				c-22.2,22.2-51.8,34.5-83.2,34.5s-61-12.2-83.2-34.5C22.9,189,10.6,159.4,10.6,128s12.2-61,34.5-83.2
				C67.3,22.5,96.9,10.3,128.3,10.3 M128.3,0.3C57.8,0.3,0.6,57.4,0.6,128s57.2,127.7,127.7,127.7S256,198.5,256,128
				S198.9,0.3,128.3,0.3L128.3,0.3z"
            />
          </g>
        </g>
        <g>
          <path
            className="ring3-after"
            style={{ fill: "#FFFFFF" }}
            id="ring-three-text"
            d="M25.1,90.3c7.9,0,13.1,5,13.1,12.6c0,7.6-5.2,12.6-13.1,12.6H14.7V90.3H25.1z M19.7,95v15.8H25
		c5.3,0,7.9-3.3,7.9-7.9c0-4.6-2.6-7.9-7.9-7.9H19.7z M47.6,92.4c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3c0-1.7,1.3-3,3-3
		C46.3,89.4,47.6,90.7,47.6,92.4z M47,115.5h-4.7V98.1H47V115.5z M64.4,103c-1.4-0.7-3.6-1.4-5.6-1.4c-1.8,0-2.7,0.6-2.7,1.6
		c0,1,1.3,1.3,2.8,1.5l1.5,0.2c3.8,0.6,5.9,2.3,5.9,5.2c0,3.6-3,5.9-8,5.9c-2.4,0-5.5-0.5-7.8-2.1l1.9-3.6c1.5,1,3.3,1.7,5.9,1.7
		c2.2,0,3.2-0.6,3.2-1.6c0-0.8-0.9-1.3-2.9-1.6l-1.4-0.2c-4-0.6-6-2.3-6-5.3c0-3.6,2.8-5.7,7.4-5.7c2.8,0,5,0.5,7.3,1.7L64.4,103z
		 M87.9,106.8c0,5.3-4,9.2-9.5,9.2c-5.4,0-9.4-3.9-9.4-9.2c0-5.3,4-9.2,9.4-9.2C83.9,97.6,87.9,101.6,87.9,106.8z M73.8,106.8
		c0,2.8,2,4.8,4.6,4.8s4.6-2,4.6-4.8c0-2.8-2-4.8-4.6-4.8S73.8,104,73.8,106.8z M103.7,98l-0.7,4.7c-0.8-0.3-1.9-0.6-2.8-0.6
		c-2.2,0-3.7,1.3-3.7,3.9v9.5h-4.7V98.1h4.6v1.9c1.1-1.6,2.8-2.4,4.9-2.4C102.2,97.6,103,97.8,103.7,98z M118.6,100v-1.9h4.6v16
		c0,5.6-3.7,9-9.4,9c-2.8,0-5.7-0.7-7.6-2.1l1.7-3.8c1.7,1.2,3.7,1.8,5.8,1.8c2.9,0,5-1.6,5-4.6v-1.2c-1.2,1.5-3,2.4-5.4,2.4
		c-4.2,0-8-3.5-8-8.9c0-5.4,3.8-8.9,8-8.9C115.7,97.6,117.4,98.6,118.6,100z M110,106.5c0,2.5,1.7,4.6,4.4,4.6c2.6,0,4.4-2,4.4-4.6
		c0-2.6-1.8-4.6-4.4-4.6C111.7,102,110,104,110,106.5z M145.3,115.5h-4.6v-1.9c-1.1,1.4-2.8,2.4-5.2,2.4c-4.8,0-8.4-3.9-8.4-9.2
		c0-5.2,3.6-9.2,8.4-9.2c2.4,0,4.1,1,5.2,2.4v-1.9h4.6V115.5z M131.9,106.8c0,2.7,1.7,4.8,4.5,4.8c2.7,0,4.5-2.1,4.5-4.8
		s-1.8-4.8-4.5-4.8C133.6,102,131.9,104.2,131.9,106.8z M166.8,104.4v11.1h-4.7V106c0-2.5-1.3-3.9-3.4-3.9c-2,0-3.7,1.3-3.7,3.9v9.6
		h-4.7V98.1h4.6v2.1c1.2-1.9,3.2-2.5,5.1-2.5C163.9,97.6,166.8,100.4,166.8,104.4z M176.9,92.4c0,1.7-1.3,3-3,3c-1.7,0-3-1.3-3-3
		c0-1.7,1.3-3,3-3C175.6,89.4,176.9,90.7,176.9,92.4z M176.2,115.5h-4.7V98.1h4.7V115.5z M195.5,101.5l-8.6,9.8h8.8v4.2h-15.3v-3.4
		l8.8-9.9h-8.5v-4.2h14.8V101.5z M215.7,106.8c0,0.5,0,1.2-0.1,1.6h-12.4c0.5,2.5,2.3,3.6,4.5,3.6c1.5,0,3.2-0.6,4.4-1.7l2.8,3
		c-2,1.8-4.5,2.6-7.4,2.6c-5.3,0-9.1-3.6-9.1-9.1s3.6-9.2,8.8-9.2C212.3,97.6,215.7,101.4,215.7,106.8z M203.3,105.2h7.7
		c-0.4-2.2-1.8-3.5-3.8-3.5C205,101.7,203.7,103,203.3,105.2z M232.1,99.9V89.6h4.7v25.9h-4.6v-1.9c-1.1,1.4-2.8,2.4-5.2,2.4
		c-4.8,0-8.4-3.9-8.4-9.2c0-5.2,3.6-9.2,8.4-9.2C229.3,97.6,230.9,98.6,232.1,99.9z M223.3,106.8c0,2.7,1.7,4.8,4.5,4.8
		c2.7,0,4.5-2.1,4.5-4.8s-1.8-4.8-4.5-4.8C225.1,102,223.3,104.2,223.3,106.8z M33.7,144.1l-3.4,2.8c-1.1-1.1-2.2-1.7-3.7-1.7
		c-2.4,0-4.4,1.9-4.4,4.8c0,2.9,1.9,4.8,4.4,4.8c1.5,0,2.8-0.7,3.8-1.8l3.3,2.9c-1.6,2.1-4.1,3.3-7,3.3c-5.6,0-9.3-3.9-9.3-9.2
		c0-5.3,3.7-9.2,9.3-9.2C29.6,140.8,32.1,142,33.7,144.1z M53.9,158.7h-4.6v-1.9c-1.1,1.4-2.8,2.4-5.2,2.4c-4.8,0-8.4-3.9-8.4-9.2
		c0-5.2,3.6-9.2,8.4-9.2c2.4,0,4.1,1,5.2,2.4v-1.9h4.6V158.7z M40.5,150c0,2.7,1.7,4.8,4.5,4.8c2.7,0,4.5-2.1,4.5-4.8
		s-1.8-4.8-4.5-4.8C42.2,145.2,40.5,147.4,40.5,150z M70.8,141.2l-0.7,4.7c-0.8-0.3-1.9-0.6-2.8-0.6c-2.2,0-3.7,1.3-3.7,3.9v9.5
		h-4.7v-17.4h4.6v1.9c1.1-1.6,2.8-2.4,4.9-2.4C69.3,140.8,70.1,141,70.8,141.2z M89.6,150c0,0.5,0,1.2-0.1,1.6H77.1
		c0.5,2.5,2.3,3.6,4.5,3.6c1.5,0,3.2-0.6,4.4-1.7l2.8,3c-2,1.8-4.5,2.6-7.4,2.6c-5.3,0-9.1-3.6-9.1-9.1c0-5.5,3.6-9.2,8.8-9.2
		C86.1,140.8,89.6,144.6,89.6,150z M77.2,148.4h7.7c-0.4-2.2-1.8-3.5-3.8-3.5C78.9,144.9,77.6,146.2,77.2,148.4z M114.9,146.2
		c-1.4-0.7-3.6-1.4-5.6-1.4c-1.8,0-2.7,0.6-2.7,1.6c0,1,1.3,1.3,2.8,1.5l1.5,0.2c3.8,0.6,5.9,2.3,5.9,5.2c0,3.6-3,5.9-8,5.9
		c-2.4,0-5.5-0.5-7.8-2.1l1.9-3.6c1.5,1,3.3,1.7,5.9,1.7c2.2,0,3.2-0.6,3.2-1.6c0-0.8-0.9-1.3-2.9-1.6l-1.4-0.2c-4-0.6-6-2.3-6-5.3
		c0-3.6,2.8-5.7,7.4-5.7c2.8,0,5,0.5,7.3,1.7L114.9,146.2z M124.8,166h-5.1l6.1-11l-7.5-13.7h5.3l4.8,9l4.6-9h5.1L124.8,166z
		 M152.8,146.2c-1.4-0.7-3.6-1.4-5.6-1.4c-1.8,0-2.7,0.6-2.7,1.6c0,1,1.3,1.3,2.8,1.5l1.5,0.2c3.8,0.6,5.9,2.3,5.9,5.2
		c0,3.6-3,5.9-8,5.9c-2.4,0-5.5-0.5-7.8-2.1l1.9-3.6c1.5,1,3.3,1.7,5.9,1.7c2.2,0,3.2-0.6,3.2-1.6c0-0.8-0.9-1.3-2.9-1.6l-1.4-0.2
		c-4-0.6-6-2.3-6-5.3c0-3.6,2.8-5.7,7.4-5.7c2.8,0,5,0.5,7.3,1.7L152.8,146.2z M171.1,145.5h-6.3v6.4c0,2.2,1.2,3,2.6,3
		c1.1,0,2.3-0.6,3.3-1.1l1.7,3.7c-1.5,1-3.3,1.8-5.8,1.8c-4.3,0-6.5-2.4-6.5-7v-6.8h-3.4v-4.2h3.4v-5.2h4.7v5.2h6.3V145.5z
		 M191.3,150c0,0.5,0,1.2-0.1,1.6h-12.4c0.5,2.5,2.3,3.6,4.5,3.6c1.5,0,3.2-0.6,4.4-1.7l2.8,3c-2,1.8-4.5,2.6-7.4,2.6
		c-5.3,0-9.1-3.6-9.1-9.1c0-5.5,3.6-9.2,8.8-9.2C187.8,140.8,191.2,144.6,191.3,150z M178.8,148.4h7.7c-0.4-2.2-1.8-3.5-3.8-3.5
		C180.5,144.9,179.2,146.2,178.8,148.4z M223.4,147.6v11.1h-4.7v-9.6c0-2.5-1.3-3.9-3.4-3.9c-2,0-3.7,1.3-3.7,3.9v9.6h-4.7v-9.6
		c0-2.5-1.3-3.9-3.4-3.9c-2,0-3.7,1.3-3.7,3.9v9.6h-4.7v-17.4h4.6v2.1c1.2-1.9,3.2-2.5,5.1-2.5c2.5,0,4.6,1.1,5.8,3
		c1.4-2.2,3.6-3,5.9-3C220.6,140.8,223.4,143.6,223.4,147.6z M240.7,146.2c-1.4-0.7-3.6-1.4-5.6-1.4c-1.8,0-2.7,0.6-2.7,1.6
		c0,1,1.3,1.3,2.8,1.5l1.5,0.2c3.8,0.6,5.9,2.3,5.9,5.2c0,3.6-3,5.9-8,5.9c-2.4,0-5.5-0.5-7.8-2.1l1.9-3.6c1.5,1,3.3,1.7,5.9,1.7
		c2.2,0,3.2-0.6,3.2-1.6c0-0.8-0.9-1.3-2.9-1.6l-1.4-0.2c-4-0.6-6-2.3-6-5.3c0-3.6,2.8-5.7,7.4-5.7c2.8,0,5,0.5,7.3,1.7L240.7,146.2
		z"
          />
        </g>
      </g>
    </svg>
  );
};

export default Three;
